<template>
	<div class="vue-calendario">
		<table class="table table-xs table-agenda" style="width: 100%; margin-bottom: 0">
			<thead>
				<tr style="color: #424242; border: none">
					<th v-if="exibeMes" class="text-center" colspan="7" style="padding: 2px">
						<div class="col-xs-2">
							<i
								class="fa icon-left fa-lg fa-fw pull-left pointer"
								style="margin-top: 7px; padding-right: 0px"
								@click.prevent="voltaMes()"
							></i>
						</div>
						<div class="col-xs-8" style="padding-left: 0px; padding-right: 0px; margin-top: 3px; margin-bottom: 3px">
							<p style="margin-bottom: 0px; margin-top: 4px">{{ nomesmes[selecionado.mes] }} - {{ selecionado.ano }}</p>
						</div>
						<div class="col-xs-2">
							<i
								class="fa icon-right fa-lg pointer fa-fw pull-right"
								style="margin-top: 7px; padding-left: 0px"
								@click.prevent="proximoMes()"
							></i>
						</div>
					</th>
				</tr>
				<tr>
					<th class="text-center" style="width: 14.28%">{{ _traducao('diasSemana', 'domingo') }}</th>
					<th class="text-center" style="width: 14.28%">{{ _traducao('diasSemana', 'segunda') }}</th>
					<th class="text-center" style="width: 14.28%">{{ _traducao('diasSemana', 'terca') }}</th>
					<th class="text-center" style="width: 14.28%">{{ _traducao('diasSemana', 'quarta') }}</th>
					<th class="text-center" style="width: 14.28%">{{ _traducao('diasSemana', 'quinta') }}</th>
					<th class="text-center" style="width: 14.28%">{{ _traducao('diasSemana', 'sexta') }}</th>
					<th class="text-center" style="width: 14.28%">{{ _traducao('diasSemana', 'sabado') }}</th>
				</tr>
			</thead>
			<tbody>
				<!--- controle.arrayMes[index][dia].dia -->
				<tr v-for="(semana, index) in controle.arrayMes" :key="index">
					<td
						v-for="(dia, idx) in controle.semana"
						:key="idx"
						class="text-center ag"
						@click.prevent="exibeInInforacoesDia(controle.arrayMes[index][idx].dia, controle.arrayMes[index][idx].mesAtual)"
						:id="validaID(controle.arrayMes[index][idx])"
						:class="{
							'pointer': controle.arrayMes[index][idx].mesAtual,
							'outro-mes': !controle.arrayMes[index][idx].mesAtual,
							'hoje': exibeHoje ? controle.arrayMes[index][idx].hoje : false,
							'success': controle.arrayMes[index][idx].semana,
							'active': controle.arrayMes[index][idx].selecionado
						}"
					>
						{{ controle.arrayMes[index][idx].dia }}
					</td>
				</tr>
			</tbody>
			<tfoot v-if="exibeBotaoHoje">
				<tr>
					<th colspan="7" style="padding: 2px">
						<button class="btn btn-xs btn-block btn-default" @click="hoje($event)">
							<i class="fa fa-map-marker fa-fw"></i>{{ _traducao('calendario', 'hoje').toUpperCase() }}
						</button>
					</th>
				</tr>
			</tfoot>
		</table>
	</div>
</template>

<style scoped>
.table .success {
	background: #e0e0e0;
}
</style>

<script>
export default {
	props: {
		exibeMes: {
			type: Boolean,
			required: false,
			default: true
		},
		exibeHoje: {
			type: Boolean,
			required: false,
			default: true
		},
		exibeBotaoHoje: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	// components: {Login},
	data() {
		return {
			selecionado: {
				mes: moment().format('MM'),
				dia: moment().format('DD'),
				ano: moment().format('YYYY'),
				data: ''
			},

			//REFERENTE A AGENDA
			mes: {
				qtdSemanas: 0,
				qtdDias: 0
			},

			listaExibir: [],
			calendar: false,
			controle: {
				semana: 7,
				diaExibido: 1,
				arrayMes: [],
				btnNovo: true,
				gerouTag: false,
				editar: false
			},

			nomesmes: [
				'',
				'Janeiro',
				'Fevereiro',
				'Março',
				'Abril',
				'Maio',
				'Junho',
				'Julho',
				'Agosto',
				'Setembro',
				'Outubro',
				'Novembro',
				'Dezembro'
			],

			diasSemana: ['', 'Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado']
		}
	},

	mounted() {
		//Dias da semana
		this.diasSemana[1] = this._traducao('diasSemana', 'domingo')
		this.diasSemana[2] = this._traducao('diasSemana', 'segunda')
		this.diasSemana[3] = this._traducao('diasSemana', 'terca')
		this.diasSemana[4] = this._traducao('diasSemana', 'quarta')
		this.diasSemana[5] = this._traducao('diasSemana', 'quinta')
		this.diasSemana[6] = this._traducao('diasSemana', 'sexta')
		this.diasSemana[7] = this._traducao('diasSemana', 'sabado')

		//Meses
		this.nomesmes[0] = this._traducao('global', 'escolha')
		this.nomesmes[1] = this._traducao('nomesMes', 'janeiro')
		this.nomesmes[2] = this._traducao('nomesMes', 'fevereiro')
		this.nomesmes[3] = this._traducao('nomesMes', 'marco')
		this.nomesmes[4] = this._traducao('nomesMes', 'abril')
		this.nomesmes[5] = this._traducao('nomesMes', 'maio')
		this.nomesmes[6] = this._traducao('nomesMes', 'junho')
		this.nomesmes[7] = this._traducao('nomesMes', 'julho')
		this.nomesmes[8] = this._traducao('nomesMes', 'agosto')
		this.nomesmes[9] = this._traducao('nomesMes', 'setembro')
		this.nomesmes[10] = this._traducao('nomesMes', 'outubro')
		this.nomesmes[11] = this._traducao('nomesMes', 'novembro')
		this.nomesmes[12] = this._traducao('nomesMes', 'dezembro')

		var dateObj = new Date()

		// pega o mes
		var mes = dateObj.getUTCMonth() + 1

		// pega o dia
		var dia = dateObj.getDate()

		// pega o ano
		var ano = dateObj.getUTCFullYear()

		// o dia selecionado rece o dia de hoje
		this.selecionado.dia = dia

		// carrega o calendário do mes selecionado
		this.carregaMes(mes, ano)
	},

	methods: {
		exibirItens(lista) {
			this.listaExibir = lista
			this.carregaMes(this.selecionado.mes, this.selecionado.ano)
		},

		marcaSemana(lista) {
			this.controle.arrayMes = this.controle.arrayMes.map((item) => {
				item = item.map((it) => {
					for (var j in lista) {
						if (it.data == lista[j].dia) {
							it.semana = true
						}
					}
					return it
				})
				return item
			})

			this.$nextTick(function () {
				this.$forceUpdate()
			})
		},

		reseta() {
			var dateObj = new Date()

			// pega o mes
			var mes = dateObj.getUTCMonth() + 1

			// pega o dia
			var dia = dateObj.getDate()

			// pega o ano
			var ano = dateObj.getUTCFullYear()

			// o dia selecionado rece o dia de hoje
			this.selecionado.dia = dia

			// carrega o calendário do mes selecionado
			this.carregaMes(mes, ano)
		},

		/*********************************************************************************************************/
		/* FUNÇÕES RELACIONADO AO CALENDÁRIO */
		/*********************************************************************************************************/

		// VOLTA PARA O DIA ATUAL
		hoje($event) {
			var dateObj = new Date()

			// pega o mes
			var mes = dateObj.getUTCMonth() + 1

			// pega o dia
			var dia = dateObj.getDate()

			// pega o ano
			var ano = dateObj.getUTCFullYear()

			// o dia selecionado rece o dia de hoje
			this.selecionado.dia = dia

			// carrega o calendário do mes selecionado
			this.carregaMes(mes, ano)

			this.$emit('click-hoje', ano + '-' + this.validaZero(mes) + '-' + this.validaZero(dia))
		},

		// VERIFICA SE É UM DIA DO MES ATUAL E RETORNA UM ID PRA ELE
		validaID(item) {
			if (item.mesAtual == true) {
				return item.dia
			} else {
				if (item.dia > 15) {
					return 'AT' + item.dia
				} else {
					return 'PT' + item.dia
				}
			}
		},

		validaZero(valor) {
			return Number(valor) < 10 ? '0' + Number(valor) : valor
		},

		// GERA A ARRAY PARA POPULAR A AGENDA COM OS DIAS E SEMANA
		carregaMes(mes, ano) {
			this.selecionado.mes = mes
			this.selecionado.ano = ano

			this.mes.qtdDias = this.contaDiasDoMes(this.selecionado.ano, this.selecionado.mes) // pega a quantidade de dias do mes
			this.mes.qtdSemanas = this.contaSemanas(this.selecionado.ano, this.selecionado.mes) // pega a quantidade de semanas do mes

			var mes = []

			this.controle.diaExibido = 1

			var iniciouExibicao = false

			var proximoMes = 1

			var qtdDiasMesAnterior = 0

			// for quantidade de semanas
			for (var s = 0; s < this.mes.qtdSemanas; s++) {
				var semana = []

				// for quantidade de dias por semana (7)
				for (var d = 0; d < this.controle.semana; d++) {
					var dadosDoDia = []

					// se a quantidade de dia a ser exibido  for menor que a quantidade total de dias do mes valida o dia
					if (this.controle.diaExibido <= this.mes.qtdDias) {
						// se não tiver iniciado a exibicão dos dias, verifica se o primeiro dia começa no d/s/t/q/q/s/s
						if (!iniciouExibicao) {
							iniciouExibicao = this.validaPrimeiroDiaDoMes(d)
						}

						// se tiver iniciado a exibição das datas
						if (iniciouExibicao) {
							dadosDoDia['selecionado'] = false
							dadosDoDia['semana'] = false

							dadosDoDia['dia'] = this.controle.diaExibido
							dadosDoDia['mesAtual'] = this.validaDiaListaExibir(dadosDoDia['dia'])

							dadosDoDia['data'] =
								this.selecionado.ano + '-' + this.validaZero(this.selecionado.mes) + '-' + this.validaZero(dadosDoDia['dia'])

							// verifica se a data é o dia atual
							if (this.validaDiaDeHoje(this.controle.diaExibido)) {
								dadosDoDia['hoje'] = true
								//dadosDoDia['selecionado'] = true
							} else {
								dadosDoDia['hoje'] = false
							}

							// adiciona mais 1 no mes exibido (isso vai até ele ser igual ou menor que q a quantidade de dias do mês)
							this.controle.diaExibido = this.controle.diaExibido + 1
						} else {
							// coloca vazio no array

							dadosDoDia['dia'] = ' '
							dadosDoDia['semana'] = false
							dadosDoDia['hoje'] = false
							dadosDoDia['mesAtual'] = false
							qtdDiasMesAnterior += 1 // qtd de dias do mes anterior a ser exibida
							dadosDoDia['selecionado'] = false
						}
					} else {
						// coloca vazio no array

						dadosDoDia['dia'] = proximoMes
						dadosDoDia['hoje'] = false
						dadosDoDia['semana'] = false
						dadosDoDia['mesAtual'] = false

						var m = Number(this.selecionado.mes) + 1
						var a = Number(this.selecionado.ano)

						if (m > 12) {
							m = 1
							a += 1
						}

						dadosDoDia['data'] = this.validaZero(a) + '-' + this.validaZero(m) + '-' + this.validaZero(dadosDoDia['dia'])

						proximoMes += 1
					}

					// add os dados do dia array de semanas
					semana[d] = dadosDoDia
				}
				// add a semana no mes
				mes[s] = semana
			}

			this.controle.arrayMes = this.processaMesAnterior(mes, qtdDiasMesAnterior) // exibe os dias do mes anterior no inicio do calendário
		},

		validaDiaListaExibir(dia) {
			if (this.listaExibir.length == 0) {
				return false
			} else {
				for (var i in this.listaExibir) {
					if (this.listaExibir[i].dia == dia) {
						return true
					}
				}
			}
		},

		// EXIBE OS DIAS DO MES ANTERIOR ANTES DE COMEÇAR O MÊS ATUAL
		processaMesAnterior(arrayMes, qtdDiasMesAnterior) {
			var mes = this.selecionado.mes
			var ano = this.selecionado.ano

			if (mes == 1) {
				ano = ano - 1
				mes = 12
			} else {
				mes = mes - 1
			}

			// pega a quantidade de dias do mes anterior ao que está sendo carregado
			var diasMesAnterior = this.contaDiasDoMes(ano, mes)

			// loop na quantidade de dias do mes anteior que tem que ser exibida
			for (qtdDiasMesAnterior; qtdDiasMesAnterior > 0; --qtdDiasMesAnterior) {
				var index = qtdDiasMesAnterior - 1
				arrayMes[0][index].dia = diasMesAnterior
				arrayMes[0][index]['data'] =
					this.validaZero(ano) + '-' + this.validaZero(mes) + '-' + this.validaZero(arrayMes[0][index].dia)
				diasMesAnterior -= 1
			}

			return arrayMes
		},

		// MARCA O DIA NO CALENDÁRIO CARREGADO
		marcaDia(dia) {
			var element = this.$el.parentElement

			// desmarca todos os dias
			$(element).find('.table-agenda td').removeClass('active')

			// marca o dia expecifico
			$(element)
				.find('#' + dia)
				.addClass('active')
		},

		// VERIFICA SE O DIA DA SEMANA PASSADO É O DIA QUE INICIA O MÊS
		validaPrimeiroDiaDoMes(diaDaSemana) {
			var mes = this.selecionado.mes - 1
			var dia = new Date(this.selecionado.ano, mes, this.controle.diaExibido)

			// getDay() retorna de 0 a 6 qual dia semana a data criada está, sendo 0: domingo, 6: sábado
			if (dia.getDay() == diaDaSemana) {
				return true
			}

			return false
		},

		// VERIFICA QUANTAS SEMANAS TEM O MÊS
		contaSemanas(ano, mes) {
			var firstOfMonth = new Date(ano, mes - 1, 1)
			var lastOfMonth = new Date(ano, mes, 0)

			var used = firstOfMonth.getDay() + lastOfMonth.getDate()

			return Math.ceil(used / 7)
		},

		// CONTA QUANTOS DIAS TEM NO MES
		contaDiasDoMes(ano, mes) {
			return Number(moment(ano + '-' + mes, 'YYYY-MM').daysInMonth())
		},

		// VERIFICA SE O DIA PASSADO É IGUAL AO DIA ATUAL DO SISTEMA
		validaDiaDeHoje(dia) {
			var dateObj = new Date()
			var mes = dateObj.getUTCMonth() + 1
			var ano = dateObj.getUTCFullYear()

			// é o mesmo mes a ano atual
			if (ano == this.selecionado.ano && mes == this.selecionado.mes) {
				if (dia == dateObj.getDate()) {
					return true
				}
			}

			return false
		},

		limpaFiltros() {
			this.carregaMes(moment().format('m'), moment().format('YYYY'))
		},

		// FUNÇÃO QUE CARREGA O MÊS ANTERIOR EM RELAÇÃO AO MES ATUAL
		voltaMes() {
			var mes = Number(this.selecionado.mes)
			var ano = Number(this.selecionado.ano)

			if (mes == 1) {
				ano = ano - 1
				mes = 12
			} else {
				mes = mes - 1
			}

			this.$emit('calendario-alterou-mes', {mes: mes, ano: ano})
			this.carregaMes(mes, ano)
		},

		// CARREGA O CALENDÁRIO DO PRÓXIMO MÊS EM RELAÇÃO AO ATUAL
		proximoMes() {
			var mes = Number(this.selecionado.mes)
			var ano = Number(this.selecionado.ano)

			if (mes == 12) {
				ano = ano + 1
				mes = 1
			} else {
				mes = mes + 1
			}

			this.$emit('calendario-alterou-mes', {mes: mes, ano: ano})
			this.carregaMes(mes, ano)
		},

		// EVENTO CLICK DE UM DIA NO CALENDÁRIO
		exibeInInforacoesDia(dia, mesAtual) {
			if (!mesAtual) {
				return false
			}

			// marca o dia no calendário
			this.marcaDia(dia)

			// adiciona no control o dia selecionado
			this.selecionado.dia = dia

			this.udpataDataAtual()
		},

		// ATUALIZA A DATA SELECIONADA SEMPRE QUE ALGUMA AÇÃO FOR FEITA NO CALENDÁRIO
		udpataDataAtual() {
			// quando existir uma mascara, aplica ela aqui
			var diaRetorno = this.selecionado.dia < 10 ? '0' + this.selecionado.dia : this.selecionado.dia
			var mesRetorno = this.selecionado.mes < 10 ? '0' + this.selecionado.mes : this.selecionado.mes
			this.selecionado.data = diaRetorno + '/' + mesRetorno + '/' + this.selecionado.ano

			this.$emit('calendario-selecionou-dia', this.selecionado)
		}
	}
}
</script>

<style>
.table-xs {
	font-size: 12px;
}

.table-xs thead tr th {
	padding: 1px;
}

.table-xs tbody tr td {
	padding: 0px;
}
</style>